var map = {
	"./01GoldenCityHafenbar.jpg": 878,
	"./AGWESER.jpg": 879,
	"./ALLEYESONUS2.jpg": 880,
	"./ALLEYESONUS_HEAD.jpg": 881,
	"./ALLEYESONUS_HEAD2.jpg": 882,
	"./Foto_Manja_Herrmann-8438.jpg": 883,
	"./GC_BIERKIRCHE.jpg": 884,
	"./GC_PUBLIKUM.jpg": 885,
	"./Impressum.jpg": 886,
	"./Lankenau.jpg": 887,
	"./Lankenau2.jpg": 888,
	"./RRR.jpg": 889,
	"./RamonaRamon_in_Athen.jpg": 890,
	"./TWS.jpg": 891,
	"./TWS_gang.jpg": 892,
	"./alleyesonus_haupt.jpg": 893,
	"./festival.jpg": 894,
	"./foerdermitglied.jpg": 895,
	"./gc_head_22.png": 896,
	"./gcapp.jpg": 897,
	"./goldencity.jpg": 898,
	"./goldencity2.jpg": 899,
	"./goldencity21.jpg": 900,
	"./goldencity3.jpg": 901,
	"./lokalrunde.jpg": 902,
	"./mystirio.jpg": 903,
	"./mythosgoldencity.jpg": 904,
	"./programm.png": 905,
	"./quarantaene.jpg": 906,
	"./quarantaene2.jpg": 907,
	"./satzung.jpg": 908,
	"./sehnsuchtslieder.jpg": 909,
	"./theater.jpg": 910,
	"./traumweltstadt.jpg": 911,
	"./wasistgoldencity.jpg": 912,
	"./wasistgoldencity2.jpg": 913,
	"./wasistgoldencity3.jpg": 914,
	"./wasistgoldencity4.jpg": 915,
	"./wasistgoldencity5.jpg": 916,
	"./zoomparty.jpg": 917
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;



//////////////////
// WEBPACK FOOTER
// ./images/head ^\.\/.*$
// module id = 877
// module chunks = 0